export const formatNumberForLocale = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "0";
  return Number(value).toLocaleString("de-DE");
};

export const parseLocaleNumber = (value) => {
  if (!value) return 0;

  const num = Number(
    value
      .toString()
      .replace(/\./g, "")
      .replace(/,/g, ".")
  );

  return isNaN(num) ? 0 : num;
};
